import { useEffect, useState } from 'react';
import {
  getPendingCount,
  subscribeHistoryBadge,
  trackPendingTask,
  reconcileHistoryBadgeWithServerTasks,
} from '@/utils/workbenchHistoryBadge';
import { useIpeWorkspaceMode } from '@/pages/ipe/workbench/hooks/useIpeWorkspaceMode';

/**
 * 历史角标：纯本地事件模型（未读 = 尚未打开对应详情），按 workspaceMode 分桶。
 * - 创建任务时 trackPendingTask → 当前 mode 桶 +1
 * - 进入详情页 / 从历史点开详情 markTaskViewedFromHistory → 当前 mode 桶 -1
 * - 切换 personal/team 立刻换桶展示
 * - 历史面板拉列表后调用 syncFromServerTasks 对齐服务端任务
 *
 * @param {string} scopeId 功能 scope（如 img2img），勿手写 mode 后缀
 * @param {{ pauseRemotePoll?: boolean }} [_options] 兼容旧调用；已忽略
 */
export default function useWorkbenchHistoryBadge(scopeId, _options = {}) {
  const workspaceMode = useIpeWorkspaceMode();
  const [count, setCount] = useState(() => getPendingCount(scopeId, workspaceMode));

  useEffect(() => {
    setCount(getPendingCount(scopeId, workspaceMode));
    return subscribeHistoryBadge(() => {
      setCount(getPendingCount(scopeId, workspaceMode));
    });
  }, [scopeId, workspaceMode]);

  const syncFromServerTasks = (tasks, options = {}) => {
    reconcileHistoryBadgeWithServerTasks(scopeId, tasks, workspaceMode, options);
  };

  return {
    count,
    workspaceMode,
    trackTask: (taskId) => trackPendingTask(scopeId, taskId, workspaceMode),
    syncFromServerTasks,
  };
}
